import type { Promo } from '@ps/web-casino-types';

import type { Entity, CasinoGame as GameEntity } from '../entities/index';
import { casinoGame } from '../entities/index';

export const promoEntity = (game: Promo, index?: number): Entity<GameEntity> =>
  casinoGame({
    gameId: game.game?.gametype ?? 0,
    gameName: game.title ?? '',
    gamePosition: typeof index === 'number' ? index + 1 : undefined,
    variantId: game.game?.variant ?? 0
  });
